import { ROLE } from "@/utils/constant";
import { SidebarMenuConfig } from "./nav-config";
import { createElement } from "react";
import { ChartColumn, List } from "lucide-react";

export const navAbdBackboneConfig: SidebarMenuConfig[] = [
  {
    href: "#",
    label: "ABD BB",
    child: [
      {
        href: "/abd-backbone/abd-bb-dashboard",
        label: "ABD BB Dashboard",
        icon: createElement(ChartColumn, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
          ROLE.ABD_RING_APPROVER,
          ROLE.ABD_RING_VERIFICATOR,
          ROLE.ABD_RING_PBO,
          ROLE.ABD_RING_MAINTENANCE,
          ROLE.ABD_RING_VIEW,
          ROLE.ABD_RING_HQ_CONSTRUCTION,
        ],
      },
      {
        href: "/abd-backbone/abd-bb-list",
        label: "ABD BB List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
          ROLE.ABD_RING_APPROVER,
          ROLE.ABD_RING_VERIFICATOR,
          ROLE.ABD_RING_PBO,
          ROLE.ABD_RING_VIEW,
          ROLE.ABD_RING_HQ_CONSTRUCTION,
        ],
      },
      {
        href: "/abd-backbone/abd-bb-submission-list",
        label: "ABD BB Submission List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
          ROLE.ABD_RING_APPROVER,
          ROLE.ABD_RING_VERIFICATOR,
          ROLE.ABD_RING_PBO,
          ROLE.ABD_RING_VIEW,
          ROLE.ABD_RING_HQ_CONSTRUCTION,
        ],
      },
      {
        href: "/abd-backbone/abd-bb-handover-list",
        label: "ABD Handover List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
          ROLE.ABD_RING_APPROVER,
          ROLE.ABD_RING_VERIFICATOR,
          ROLE.ABD_RING_PBO,
          ROLE.ABD_RING_MAINTENANCE,
          ROLE.ABD_RING_VIEW,
          ROLE.ABD_RING_HQ_CONSTRUCTION,
        ],
      },
    ],
  },
  {
    href: "#",
    label: "ABD FO OLT",
    child: [
      {
        href: "/abd-backbone/abd-fo-olt-dashboard",
        label: "ABD FO OLT Dashboard",
        icon: createElement(ChartColumn, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
          ROLE.ABD_FOOLT_APPROVER,
          ROLE.ABD_FOOLT_VERIFICATOR,
          ROLE.ABD_FOOLT_PBO,
          ROLE.ABD_FOOLT_MAINTENANCE,
          ROLE.ABD_FOOLT_VIEW,
          ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
        ],
      },
      {
        href: "/abd-backbone/abd-fo-olt-list",
        label: "ABD FO OLT List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
          ROLE.ABD_FOOLT_APPROVER,
          ROLE.ABD_FOOLT_VERIFICATOR,
          ROLE.ABD_FOOLT_PBO,
          ROLE.ABD_FOOLT_VIEW,
          ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
        ],
      },
      {
        href: "/abd-backbone/abd-fo-olt-submission-list",
        label: "ABD FO OLT Submission List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
          ROLE.ABD_FOOLT_APPROVER,
          ROLE.ABD_FOOLT_VERIFICATOR,
          ROLE.ABD_FOOLT_PBO,
          ROLE.ABD_FOOLT_VIEW,
          ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
        ],
      },
      {
        href: "/abd-backbone/abd-fo-olt-handover-list",
        label: "ABD FO OLT Handover List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
          ROLE.ABD_FOOLT_APPROVER,
          ROLE.ABD_FOOLT_VERIFICATOR,
          ROLE.ABD_FOOLT_PBO,
          ROLE.ABD_FOOLT_MAINTENANCE,
          ROLE.ABD_FOOLT_VIEW,
          ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
        ],
      },
    ],
  },
];

export const navAbdLastmileFeeder: SidebarMenuConfig[] = [
  {
    href: "#",
    label: "ABD LM Feeder",
    child: [
      {
        href: "/abd-backbone/abd-feeder-dashboard",
        label: "ABD Lastmile & Feeder Dashboard",
        icon: createElement(ChartColumn, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_FEEDER_VIEW,
          ROLE.ABD_FEEDER_VERIFICATOR_LM,
          ROLE.ABD_FEEDER_VERIFICATOR,
          ROLE.ABD_FEEDER_APPROVER,
          ROLE.ABD_FEEDER_PBO,
          ROLE.ABD_FEEDER_MAINTENANCE,
        ],
      },
      {
        href: "/abd-backbone/abd-feeder-list",
        label: "ABD Lastmile & Feeder List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_FEEDER_VIEW,
          ROLE.ABD_FEEDER_VERIFICATOR_LM,
          ROLE.ABD_FEEDER_VERIFICATOR,
          ROLE.ABD_FEEDER_APPROVER,
          ROLE.ABD_FEEDER_PBO,
        ],
      },
      {
        href: "/abd-backbone/abd-feeder-submission-list",
        label: "ABD Lastmile & Feeder Submission List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.VENDOR,
          ROLE.VENDOR_VIEW,
          ROLE.ABD_FEEDER_VIEW,
          ROLE.ABD_FEEDER_VERIFICATOR_LM,
          ROLE.ABD_FEEDER_VERIFICATOR,
          ROLE.ABD_FEEDER_APPROVER,
          ROLE.ABD_FEEDER_PBO,
        ],
      },
      {
        href: "/abd-backbone/abd-feeder-handover-list",
        label: "ABD Feeder Handover List",
        icon: createElement(List, { width: 20, height: 20 }),
        allowedRoles: [
          ROLE.ABD_FEEDER_VERIFICATOR_LM,
          ROLE.ABD_FEEDER_VERIFICATOR,
          ROLE.ABD_FEEDER_APPROVER,
          ROLE.ABD_FEEDER_PBO,
          ROLE.ABD_FEEDER_MAINTENANCE,
          ROLE.ABD_FEEDER_VIEW,
        ],
      },
    ],
  },
];
